<template>
    <router-view v-if="isRouterAlive"></router-view>
</template>

<script>

  export default {
    provide () {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      };
    },
    methods: {
      reload () {
        this.isRouterAlive = false
        this.$nextTick(() => (this.isRouterAlive = true))
      }
    },
    mounted() {
    }
  };
</script>

<style>
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    
  }
  
  html, body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  
  h1 {
    font-size: 18px;
  }
  
  h2 {
    font-size: 16px;
  }
  
  h3 {
    font-size: 14px;
  }
  
  h4, h5, h6 {
    font-size: 100%;
  }
  
  a {
    text-decoration: none;
    cursor: pointer;
  }
  
  fieldset, img {
    border: none;
  }
  
  :focus {
    outline: 0;
    -webkit-tap-highlight-color: transparent;
  }
  .el-form-item__label {
      height: 30px;
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 12px;
      color: #606266;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
  }
  .el-form--label-top .el-form-item__label {
      float: none;
      display: inline-block;
      text-align: left;
      padding: 0 0;
  }
  .but-cls {
      margin-bottom: 10px;
  }
  .cls-col {
      margin-right: 20px;
  }
</style>
